import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "@components/sidebar";
import { useSelector, useDispatch } from "react-redux";
import { getAttendees } from "../../redux/slice/attendees";
import { Form, Button } from "reactstrap";
import { setFilterModalParamsAtt } from "./../../redux/slice/const";
import {
  Filter,
  CheckCircle,
  XCircle,
  Tag,
  RotateCcw,
  Check,
} from "react-feather";
import "./styles.scss";

export default function FiltersSideBarAttendees() {
  const { filterModalParamsAtt } = useSelector((store) => store.globalConst);
  const [subscriptionSelected, setSubscriptionSelected] = useState({});
  const [count, setCount] = useState(0);
  const [keys, setKeys] = useState([]);
  const dispatch = useDispatch();
  let valueArray = [];

  const closeModal = () => {
    dispatch(
      setFilterModalParamsAtt({
        show: false,
        view: filterModalParamsAtt?.view,
        values: filterModalParamsAtt?.value,
        data: filterModalParamsAtt?.data,
        args: filterModalParamsAtt?.args,
        state: filterModalParamsAtt?.state,
        select: filterModalParamsAtt?.select,
        disable: filterModalParamsAtt?.disable,
      })
    );
  };

  const getSectionIcon = (sectionName) => {
    switch (sectionName) {
      case "asistencia":
        return <CheckCircle size={14} />;
      case "constancia":
        return <Filter size={14} />;
      case "kit":
        return <Tag size={14} />;
      default:
        return <Filter size={14} />;
    }
  };

  const getSectionLabel = (sectionName) => {
    switch (sectionName) {
      case "asistencia":
        return "Asistencia";
      case "constancia":
        return "Constancia";
      case "kit":
        return "Kit";
      default:
        return sectionName;
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let status, label;
    const form = e.target;
    const inputs = form.querySelectorAll("input");
    const data = [...Object.entries(filterModalParamsAtt?.data[0])];

    inputs.forEach(({ value, checked, id, name }) => {
      if (checked) {
        if (name === "asistencia") {
          valueArray[0] = {
            // eslint-disable-next-line no-unneeded-ternary
            status: value === "true" ? true : false,
            label: id,
            section: "checkIn",
          };
        } else if (name === "constancia") {
          if (valueArray[0] === undefined) {
            valueArray[0] = [];
          }
          valueArray[1] = {
            // eslint-disable-next-line no-unneeded-ternary
            status: value === "true" ? true : false,
            label: id,
            section: "certificate",
          };
        } else if (name === "kit") {
          if (valueArray[1] === undefined) {
            valueArray[1] = [];
          }
          valueArray[2] = {
            // eslint-disable-next-line no-unneeded-ternary
            status: value === "true" ? true : false,
            label: id,
            section: "kit",
          };
        }
      }
    });

    Object.entries(filterModalParamsAtt?.data[0]).forEach((e, i) => {
      e[1].forEach((element, index) => {
        valueArray.forEach((element2) => {
          if (element.label === element2.label) {
            const array3 = [...data[i]];
            const array2 = [...data[i][1]];
            const array1 = { ...data[i][1][index] };
            array1.checked = true;
            array2.splice(index, 1, array1);
            array3.splice(1, 1, array2);
            data.splice(i, 1, array3);
          }
        });
      });
    });

    const args = {
      eventId: filterModalParamsAtt.args.eventId,
      searchQuery: filterModalParamsAtt.args.searchQuery,
      checkin: valueArray[0]?.status,
      certificate: valueArray[1]?.status,
      kit: valueArray[2]?.status,
      subscriptionId: subscriptionSelected.value,
    };

    if (Object.keys(subscriptionSelected).length !== 0) {
      valueArray.push({
        value: subscriptionSelected.value,
        label: subscriptionSelected?.label,
        section: "select",
      });
    }

    dispatch(getAttendees(args));
    dispatch(
      setFilterModalParamsAtt({
        show: false,
        view: filterModalParamsAtt.view,
        values: "",
        data: [Object.fromEntries(data)],
        args,
        state: valueArray,
        select: subscriptionSelected,
        disable: true,
      })
    );
    setCount(0);
    setSubscriptionSelected([]);
  };

  const clearFilter = () => {
    const args = {
      eventId: filterModalParamsAtt.args.eventId,
      searchQuery: filterModalParamsAtt.searchQuery,
    };

    dispatch(getAttendees(args));
    dispatch(
      setFilterModalParamsAtt({
        show: false,
        view: "",
        data: "",
        args: {},
        state: [],
        select: {},
        disable: true,
      })
    );
    valueArray = [];
    setSubscriptionSelected({});
  };

  useEffect(() => {
    if (filterModalParamsAtt.show === true) {
      setKeys([]);
      setKeys(Object.entries(filterModalParamsAtt?.data[0]));
      setCount((curr) => curr + 1);
    }
  }, [filterModalParamsAtt]);

  return (
    <Sidebar
      size="sm"
      title="Filtros"
      headerClassName="mb-1"
      open={filterModalParamsAtt.show}
      contentClassName="pt-0 mb-0 bg-white"
      backdrop="static"
      toggleSidebar={() => {
        closeModal();
      }}
    >
      <div className="filter-sidebar">
        <Form onSubmit={onSubmit}>
          {filterModalParamsAtt?.show &&
            keys.map((e, i) => {
              if (e[0] !== "subscription") {
                return (
                  <div key={i} className="filter-section">
                    <div className="filter-section-title">
                      {getSectionIcon(e[0])}
                      {getSectionLabel(e[0])}
                    </div>
                    <div className="filter-options">
                      {e[1]?.map((element, index) => (
                        <label
                          key={index}
                          className={`filter-option ${
                            element.checked ? "selected" : ""
                          }`}
                        >
                          <input
                            type="radio"
                            name={`${e[0]}`}
                            id={element.label}
                            value={element.value}
                            defaultChecked={element.checked}
                            onClick={() => {
                              dispatch(
                                setFilterModalParamsAtt({
                                  show: filterModalParamsAtt.show,
                                  view: filterModalParamsAtt.view,
                                  data: filterModalParamsAtt.data,
                                  args: filterModalParamsAtt.args,
                                  state: filterModalParamsAtt.state,
                                  disable: false,
                                })
                              );
                            }}
                          />
                          <span>{element.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div key={i} className="filter-select-section">
                    <div className="filter-section-title">
                      <Tag size={14} />
                      Tipo de boleto
                    </div>
                    <Select
                      isClearable
                      id="suscriptionKind"
                      defaultValue={
                        filterModalParamsAtt?.select !== undefined
                          ? filterModalParamsAtt?.select
                          : {}
                      }
                      options={e[1]}
                      className="react-select"
                      classNamePrefix="select"
                      placeholder="Selecciona un tipo..."
                      noOptionsMessage={() => "Sin opciones"}
                      onChange={(selected) => {
                        if (selected) {
                          setSubscriptionSelected({
                            value: selected.value,
                            label: selected.label,
                            section: "select",
                          });
                        } else {
                          setSubscriptionSelected({});
                        }
                        dispatch(
                          setFilterModalParamsAtt({
                            show: filterModalParamsAtt.show,
                            view: filterModalParamsAtt.view,
                            data: filterModalParamsAtt.data,
                            args: filterModalParamsAtt.args,
                            state: filterModalParamsAtt.state,
                            disable: false,
                          })
                        );
                      }}
                    />
                  </div>
                );
              }
            })}

          <div className="filter-footer">
            {filterModalParamsAtt?.state?.length > 0 && (
              <Button type="button" className="btn-clear" onClick={clearFilter}>
                <RotateCcw size={16} />
                Limpiar
              </Button>
            )}
            <Button
              type="submit"
              className="btn-apply"
              disabled={filterModalParamsAtt.disable}
            >
              <Check size={16} />
              Aplicar
            </Button>
          </div>
        </Form>
      </div>
    </Sidebar>
  );
}
